import { TimeoutAction } from '../../enums';
import { IsEnum, IsUUID } from 'class-validator';

export class SetUserTimeoutDto {
	@IsUUID()
	lobbyId: string;

	@IsEnum(TimeoutAction)
	action: TimeoutAction;

	@IsUUID()
	userId: string;
}
